import { useForm } from '@inertiajs/react'
import { FormEvent } from 'react'

interface Props {
  user: {
    id: number
    email: string
  }
  errors?: Record<string, string>
}

export default function EditProfile({ user, errors }: Props) {
  const { data, setData, patch, processing } = useForm({
    email: user.email,
    password: '',
    password_confirmation: '',
    current_password: '',
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    patch('/users')
  }

  return (
    <div className="profile-container">
      <form onSubmit={handleSubmit}>
        <h1>Edit Profile</h1>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={data.email}
            onChange={(e) => setData('email', e.target.value)}
            required
            aria-invalid={!!errors?.email}
          />
          {errors?.email && <span className="error-message">{errors.email}</span>}
        </div>

        <hr />

        <h2>Change Password</h2>

        <div className="form-group">
          <label htmlFor="password">New Password</label>
          <input
            id="password"
            type="password"
            placeholder="Leave blank to keep current password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            aria-invalid={!!errors?.password}
          />
          {errors?.password && <span className="error-message">{errors.password}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="password_confirmation">Confirm New Password</label>
          <input
            id="password_confirmation"
            type="password"
            placeholder="Confirm new password"
            value={data.password_confirmation}
            onChange={(e) => setData('password_confirmation', e.target.value)}
            aria-invalid={!!errors?.password_confirmation}
          />
          {errors?.password_confirmation && (
            <span className="error-message">{errors.password_confirmation}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="current_password">Current Password</label>
          <input
            id="current_password"
            type="password"
            placeholder="Required to confirm changes"
            value={data.current_password}
            onChange={(e) => setData('current_password', e.target.value)}
            required
            aria-invalid={!!errors?.current_password}
          />
          {errors?.current_password && (
            <span className="error-message">{errors.current_password}</span>
          )}
        </div>

        <button type="submit" disabled={processing}>
          {processing ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  )
}
